import {call, delay, put, takeLatest} from 'redux-saga/effects'
import {globalActionTypes} from 'src/app/modules/errors/redux/constants'
import {ActionModel} from 'src/cms/helpers/Models/ActionModel'
import {ResponseModel} from 'src/cms/helpers/Models/ResponseModel'
import {actions} from './action'
import {actionTypes} from './constants'
import {service} from './service'

function* getTisaForexRateCategorySaga(action: ActionModel) {
  try {
    const params: any = action.payload?.params
    yield delay(500)
    const response: ResponseModel = yield call(service.getTisaForexRateCategory, params)
    yield put(actions.getTisaForexRateCategorySuccess(response?.data))
    yield put(actions.getTisaForexRateCategoryFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.getTisaForexRateCategoryFinish())
  }
}

function* getAllTisaForexRateCategorySaga(action: ActionModel) {
  try {
    const params: any = action.payload?.params
    const response: ResponseModel = yield call(service.getAllTisaForexRateCategory, params)
    yield put(actions.getAllTisaForexRateCategorySuccess(response?.data))
    yield put(actions.getAllTisaForexRateCategoryFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.getAllTisaForexRateCategoryFinish())
  }
}

function* addTisaForexRateCategorySaga(action: ActionModel) {
  try {
    const body = action.payload
    const response: ResponseModel = yield call(service.addTisaForexRateCategory, body)
    yield put(actions.addTisaForexRateCategorySuccess(response.data?.data))
    yield put(actions.addTisaForexRateCategoryFinish())
  } catch (err: any) {
    if (err.response) {
      const errorData = err.response.data
      const message =
        errorData?.errors
          ? Object.values(errorData.errors).flat().join(' ')
          : errorData.message
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: message})
    }
    yield put(actions.addTisaForexRateCategoryFinish())
  }
}

function* updateTisaForexRateCategorySaga(action: ActionModel) {
  try {
    const body: any = action.payload?.data
    const response: ResponseModel = yield call(
      service.updateTisaForexRateCategory,
      body,
      action.payload?.id
    )
    yield put(actions.updateTisaForexRateCategorySuccess(response.data?.data))
    yield put(actions.updateTisaForexRateCategoryFinish())
  } catch (err: any) {
    if (err.response) {
      const errorData = err.response.data
      const message =
        errorData?.errors
          ? Object.values(errorData.errors).flat().join(' ')
          : errorData.message
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: message})
    }
    yield put(actions.updateTisaForexRateCategoryFinish())
  }
}

function* deleteTisaForexRateCategorySaga(action: ActionModel) {
  try {
    const body: any = action.payload
    const response: ResponseModel = yield call(service.deleteTisaForexRateCategory, body)
    yield put(actions.deleteTisaForexRateCategorySuccess(response.data?.data))
    yield put(actions.deleteTisaForexRateCategoryFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.deleteTisaForexRateCategoryFinish())
  }
}

function* singleActivateTisaForexRateCategorySaga(action: ActionModel) {
  try {
    const categoryIds: Array<{id: string}> = action.payload as any
    const response: ResponseModel = yield call(
      service.singleActivateTisaForexRateCategory,
      categoryIds
    )
    yield put(actions.singleActivateTisaForexRateCategorySuccess(response?.data?.data))
    yield put(actions.singleActivateTisaForexRateCategoryFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.singleActivateTisaForexRateCategoryFinish())
  }
}

function* singleDeactivateTisaForexRateCategorySaga(action: ActionModel) {
  try {
    const categoryIds: Array<{id: string}> = action.payload as any
    const response: ResponseModel = yield call(
      service.singleDeactivateTisaForexRateCategory,
      categoryIds
    )
    yield put(actions.singleDeactivateTisaForexRateCategorySuccess(response?.data?.data))
    yield put(actions.singleDeactivateTisaForexRateCategoryFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.singleDeactivateTisaForexRateCategoryFinish())
  }
}

export function* saga() {
  yield takeLatest(actionTypes.GET_TISA_FOREX_RATE_CATEGORY_START, getTisaForexRateCategorySaga)
  yield takeLatest(
    actionTypes.GET_ALL_TISA_FOREX_RATE_CATEGORY_START,
    getAllTisaForexRateCategorySaga
  )
  yield takeLatest(actionTypes.ADD_TISA_FOREX_RATE_CATEGORY_START, addTisaForexRateCategorySaga)
  yield takeLatest(
    actionTypes.UPDATE_TISA_FOREX_RATE_CATEGORY_START,
    updateTisaForexRateCategorySaga
  )
  yield takeLatest(
    actionTypes.DELETE_TISA_FOREX_RATE_CATEGORY_START,
    deleteTisaForexRateCategorySaga
  )
  yield takeLatest(
    actionTypes.SINGLE_ACTIVATE_TISA_FOREX_RATE_CATEGORY_REQUEST,
    singleActivateTisaForexRateCategorySaga
  )
  yield takeLatest(
    actionTypes.SINGLE_DEACTIVATE_TISA_FOREX_RATE_CATEGORY_REQUEST,
    singleDeactivateTisaForexRateCategorySaga
  )
}
